const useWebView = (router) => {
  // if (sessionStorage.getItem('is_mobile') === '1') {
  //   return true;
  // }

  if (router?.query?.is_mobile === '1') {
    // sessionStorage.setItem('is_mobile', '1');
    return true;
  } 
};

export default useWebView;
